import React from "react";
import { useQuery, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BentoGrid, BentoGridItem } from "./bento-grid";
import { decodeHtmlEntities } from "../../lib/utils";

const queryClient = new QueryClient();

const Skeleton = () => (
    <div className="w-full aspect-video bg-[var(--line)] animate-pulse" />
);

const API_KEY = "AIzaSyBZJZ4WDscdRgukP6ed7Qm8Lvr_chp9BCE";
const CHANNEL_ID = "UCmEgRY1A2263UXrQhjDuU0Q";

const fetchVideos = async () => {
    const url = `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=9`;
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return (data.items || []).filter((item) => item.id?.videoId);
};

function BentoGridDemo() {
    const { data: videos, isLoading, isError, error } = useQuery({
        queryKey: ["youtubeVideos", "decoded"],
        queryFn: fetchVideos,
        staleTime: 24 * 60 * 60 * 1000,
        cacheTime: 24 * 60 * 60 * 1000,
    });

    if (isLoading) {
        return (
            <BentoGrid className="max-w-7xl mx-auto">
                {Array.from({ length: 6 }).map((_, i) => (
                    <BentoGridItem key={i} header={<Skeleton />} />
                ))}
            </BentoGrid>
        );
    }

    if (isError) {
        return <p className="text-sm text-[var(--muted)]">Videolar yüklenemedi: {error.message}</p>;
    }

    if (!videos?.length) {
        return null;
    }

    return (
        <BentoGrid className="max-w-7xl mx-auto">
            {videos.map((video) => {
                const videoId = video.id.videoId;
                const title = decodeHtmlEntities(video.snippet.title);
                const thumb =
                    video.snippet.thumbnails.high?.url ||
                    video.snippet.thumbnails.medium?.url ||
                    video.snippet.thumbnails.default?.url;
                return (
                    <BentoGridItem
                        key={videoId}
                        header={
                            <a
                                href={`https://www.youtube.com/watch?v=${videoId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block w-full"
                            >
                                <div className="aspect-video overflow-hidden bg-[var(--line)]">
                                    <img
                                        src={thumb}
                                        alt={title}
                                        loading="lazy"
                                        decoding="async"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <p className="mt-3 px-1 text-sm font-medium text-[var(--ink)] line-clamp-2 leading-snug">
                                    {title}
                                </p>
                            </a>
                        }
                    />
                );
            })}
        </BentoGrid>
    );
}

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <BentoGridDemo />
        </QueryClientProvider>
    );
}
